import * as yup from 'yup';

import { kfzContractBaseSchema } from '@/features/Contract/KFZ/contractBaseSchema';
import { erstfahrzeugContractSchema } from '@/features/Sparten/shared/schema/kfz/erstfahrzeugSchema/erstfahrzeugContractSchema';
import { fahrzeugContractSchema } from '@/features/Sparten/shared/schema/kfz/fahrzeugSchema/fahrzeugContractSchema';
import { vorfahrzeugContractSchema } from '@/features/Sparten/shared/schema/kfz/vorfahrzeugSchema/vorfahrzeugContractSchema';
import { locales } from '@/features/validation/locales';
import { eVBContractSchema } from '@/features/Sparten/shared/schema/kfz/eVBSchema/eVBContractSchema';

yup.setLocale(locales);

const kradContractSchema = yup.object({
  erstfahrzeug: erstfahrzeugContractSchema,
  evb: eVBContractSchema,
  fahrzeugdaten: fahrzeugContractSchema,
  vorfahrzeug: vorfahrzeugContractSchema,
});

export const contractSchema = kfzContractBaseSchema.concat(kradContractSchema);
